import React from 'react';
import { email, requiredEmail } from 'Utils/FormValidation';
import { PrimaryText } from 'Components/Texts';
import { SubmitButton } from 'Components/Fields/Buttons';
import { SubmitError } from 'Components/Fields/SubmitError';
import { useForm } from 'Hooks/useForm';
import { useStore } from 'Hooks/useStore';
import { FormField } from 'Components/HookFormFields/FormField';
import './GetEmailForm.css';

const GetEmailForm = ({ onFormSubmit }) => {
  const user = useStore('user');
  const formName = 'getEmailForm';
  const { formFieldProps, submitting, submitDisabled, formError, handleSubmit } = useForm({
    onFormSubmit,
    formName,
    initialValues: { email: user?.email || '' },
  });
  return (
    <div className="getEmailFormPanel">
      <div className="getEmailFormPanelWrapper">
        <form onSubmit={(event) => handleSubmit(event)} className={formName}>
          <PrimaryText
            alignText="centerText"
            text="Enter your email address below and we'll send you instructions to reset your password."
            className="secondaryText"
          />
          <FormField
            className="emailField"
            name="email"
            label="Email"
            component="EmailField"
            validate={[requiredEmail, email]}
            autofocus
            {...formFieldProps}
          />
          <SubmitError error={formError} formName={formName} />
          <SubmitButton
            className="pillButton"
            text="Reset Password"
            submitting={submitting}
            isDisabled={submitDisabled}
          />
        </form>
      </div>
    </div>
  );
};

export default GetEmailForm;
